export * from './service/index.js'
export * from './migrations/index.js'
export * from './controllers/index.js'

import './routes.js'

import Koa from 'koa'
import { getPermission } from '@things-factory/operato-license-checker'

interface ProhibitedPrivilege {
  privilege: string
  category: string
}

/**
 * Board 서비스 미들웨어 초기화.
 * 라이선스 권한에 따라 board/board-template mutation을 제한한다.
 */
export function initMiddlewares(app: Koa) {
  const licensedPermissions = (getPermission('Permissions For Board Usage') || 'Modeller, Viewer')
    .split(',')
    .map(p => p.trim())

  const prohibited: ProhibitedPrivilege[] | false = !licensedPermissions.includes('Modeller') && [
    { privilege: 'mutation', category: 'board' },
    { privilege: 'mutation', category: 'board-template' }
  ]

  app.use(async (context, next) => {
    if (prohibited) {
      const existing: ProhibitedPrivilege[] = context.state.prohibitedPrivileges || []
      context.state.prohibitedPrivileges = [...existing, ...prohibited]
    }
    await next()
  })
}
